<template>
	<div class="element element--loader">
		<label class="element__label">{{ label }}</label>
		<div class="element__loader"></div>
		<ElementSubIcon name="loader" />
	</div>
</template>

<script>
export default {
	props: {
		label: String,
	},
};
</script>

<style lang="scss"></style>
